import { isDate } from "lodash"
import moment from "moment"

export const getDateDiff = (previousDate, futureDate) => {
  const date1 = isDate(previousDate) ? previousDate : new Date(previousDate)
  const date2 = isDate(futureDate) ? futureDate : new Date(futureDate)

  const diff = new Date(date2.getTime() - date1.getTime())

  return {
    years: diff.getFullYear() - 1970,
    months: diff.getMonth(),
    days: diff.getDate() - 1,
    hours: diff.getHours(),
    minutes: diff.getMinutes(),
    seconds: diff.getSeconds(),
  }
}

export const calculateAge = (
  birthdate,
  evaluateAt = null,
  formatInYears = true,
) => {
  if (!birthdate) {
    return null
  }

  return moment(evaluateAt).diff(
    moment(birthdate),
    formatInYears ? "years" : "months",
  )
}
